import type { DevsistersGamesItemStatus } from './devsistersGames/DevsistersGamesItem';
import * as React from 'react';
import { rem } from 'polished';

import { styled } from '../themeContext';
import DevsistersGamesItem from './devsistersGames/DevsistersGamesItem';

interface DevsistersGamesProps {
  className?: string,
  onClickItem?: () => void,
  otherGames: readonly GatsbyTypes.DevsistersGamesGameItemFragment[],
  upcomingLabel: string,
  preLabel: string,
}

const Container = styled('div')((props) => ({
  paddingBottom: rem(100),
  [props.theme.media['md']]: {
    paddingBottom: rem(0),
  },
  [props.theme.media['lg']]: {
    position: 'absolute',
    left: 0,
    width: rem(480),
    background: 'rgba(25,29,36,0.95)',
  },
}));

const DevsistersGames: React.FC<DevsistersGamesProps> = ({
  className,
  onClickItem,
  otherGames,
  upcomingLabel,
  preLabel,
}) => {
  return (
    <Container
      className={className}
      data-testid="devsisters-games-container"
    >
      {otherGames.map(game => (
        <DevsistersGamesItem
          key={game.id}
          game={game}
          onClick={onClickItem}
          upcomingLabel={upcomingLabel}
          preLabel={preLabel}
        />
      ))}
    </Container>
  );
};

export default DevsistersGames;
